import { Component, input } from '@angular/core';

import { SupplementaryFertilizerAdvisedNotificationDto } from '../../../shared/models/models';
import { TranslatePipe } from '@next/core-lib/i18n';

@Component({
    selector: 'app-supplementary-fertilizer-advised-body',
    templateUrl: './supplementary-fertilizer-advised-body.component.html',
    styleUrls: ['./supplementary-fertilizer-advised-body.component.scss'],
    imports: [TranslatePipe],
})
export class SupplementaryFertilizerAdvisedBodyComponent {
  notification = input.required<SupplementaryFertilizerAdvisedNotificationDto>();
}
